import { useState, createContext } from "react";

export const FormValueContext = createContext({});

function FormValueProvider({ children }) {

    const [inputArcade, setInputArcade] = useState(false);
    const [inputAdvanced, setInputAdvanced] = useState(false);
    const [inputPro, setInputPro] = useState(false);
    const [isYearly, setIsYearly] = useState(false);

    const [onlineservice, setOnlineService] = useState(false);
    const [largerStorage, setLargerStorage] = useState(false);
    const [customProfile, setCustomProfile] = useState(false);

    const [textPlan, setTextPlan] = useState('');
    const [totalPrice, setTotalPrice] = useState(0);
    const [textPricePlan, setTextPricePlan] = useState(0);

    return (
        <FormValueContext.Provider value={{ inputArcade, setInputArcade, inputAdvanced, setInputAdvanced, inputPro, setInputPro, isYearly, setIsYearly, onlineservice, setOnlineService, largerStorage, setLargerStorage, customProfile, setCustomProfile, textPlan, setTextPlan, totalPrice, setTotalPrice, textPricePlan, setTextPricePlan }}>
            {children}
        </FormValueContext.Provider>
    )
}

export default FormValueProvider;